// src/nova-commanding-centralized.interface.ts
var EntityVisibilityState;
(function(EntityVisibilityState2) {
  EntityVisibilityState2["show"] = "show";
  EntityVisibilityState2["hide"] = "hide";
  EntityVisibilityState2["toggle"] = "toggle";
})(EntityVisibilityState || (EntityVisibilityState = {}));
var EntityStateTransition;
(function(EntityStateTransition2) {
  EntityStateTransition2["none"] = "none";
  EntityStateTransition2["flush"] = "flush";
  EntityStateTransition2["forceFlush"] = "forceFlush";
  EntityStateTransition2["new"] = "new";
  EntityStateTransition2["extend"] = "extend";
})(EntityStateTransition || (EntityStateTransition = {}));
var EntityAction;
(function(EntityAction2) {
  EntityAction2["create"] = "create";
  EntityAction2["default"] = "default";
  EntityAction2["view"] = "view";
  EntityAction2["list"] = "list";
  EntityAction2["info"] = "info";
  EntityAction2["delete"] = "delete";
  EntityAction2["signout"] = "signout";
  EntityAction2["updateProfilePicture"] = "updateProfilePicture";
  EntityAction2["updateDisplayName"] = "updateDisplayName";
})(EntityAction || (EntityAction = {}));
var EntityType;
(function(EntityType2) {
  EntityType2["identity"] = "identity";
  EntityType2["teams_activity"] = "teams_activity";
  EntityType2["teams_chat"] = "teams_chat";
  EntityType2["teams_channel"] = "teams_channel";
  EntityType2["teams_calendar"] = "teams_calendar";
  EntityType2["teams_calling"] = "teams_calling";
  EntityType2["teams_search"] = "teams_search";
  EntityType2["outlook_mail"] = "outlook_mail";
  EntityType2["outlook_calendar"] = "outlook_calendar";
  EntityType2["outlook_people"] = "outlook_people";
  EntityType2["outlook_groups"] = "outlook_groups";
  EntityType2["outlook_fileshub"] = "outlook_fileshub";
  EntityType2["outlook_tasks"] = "outlook_tasks";
  EntityType2["m365_app"] = "m365_app";
  EntityType2["m365_appsideload"] = "m365_appsideload";
  EntityType2["m365_messageextension"] = "m365_messageextension";
  EntityType2["office_home"] = "office_home";
  EntityType2["office_create"] = "office_create";
  EntityType2["office_mycontent"] = "office_mycontent";
  EntityType2["office_spaces"] = "office_spaces";
  EntityType2["office_outlook"] = "office_outlook";
  EntityType2["office_teams"] = "office_teams";
  EntityType2["office_word"] = "office_word";
  EntityType2["office_excel"] = "office_excel";
  EntityType2["office_powerpoint"] = "office_powerpoint";
  EntityType2["office_onenote"] = "office_onenote";
  EntityType2["office_sway"] = "office_sway";
  EntityType2["office_forms"] = "office_forms";
  EntityType2["office_visio"] = "office_visio";
  EntityType2["office_stream"] = "office_stream";
  EntityType2["office_onedrive"] = "office_onedrive";
  EntityType2["office_todo"] = "office_todo";
  EntityType2["office_familysafety"] = "office_familysafety";
  EntityType2["office_calendar"] = "office_calendar";
  EntityType2["office_skype"] = "office_skype";
})(EntityType || (EntityType = {}));
export {
  EntityAction,
  EntityStateTransition,
  EntityType,
  EntityVisibilityState
};
